var map = {
	"./auth-modules/login/login.module": [
		"../../../../../src/app/auth-modules/login/login.module.ts",
		"login.module"
	],
	"./auth-modules/reset-password/reset-password.module": [
		"../../../../../src/app/auth-modules/reset-password/reset-password.module.ts",
		"reset-password.module"
	],
	"./document-submission/document-submission.module": [
		"../../../../../src/app/layout/modules/admin/document-submission/document-submission.module.ts",
		"common",
		"document-submission.module"
	],
	"./elective-and-field-seminar/elective-and-field-seminar.module": [
		"../../../../../src/app/layout/modules/admin/elective-and-field-seminar/elective-and-field-seminar.module.ts",
		"common"
	],
	"./layout/layout.module": [
		"../../../../../src/app/layout/layout.module.ts",
		"common",
		"layout.module"
	],
	"./library/library.module": [
		"../../../../../src/app/layout/modules/admin/library/library.module.ts",
		"common",
		"library.module"
	],
	"./mobility-programme/mobility-programme.module": [
		"../../../../../src/app/layout/modules/admin/mobility-programme/mobility-programme.module.ts",
		"mobility-programme.module"
	],
	"./module-creation/module-creation.module": [
		"../../../../../src/app/layout/modules/admin/programme/module-creation/module-creation.module.ts",
		"common",
		"module-creation.module"
	],
	"./modules/admin/admin.module": [
		"../../../../../src/app/layout/modules/admin/admin.module.ts",
		"common",
		"admin.module"
	],
	"./news-and-events/news-and-events.module": [
		"../../../../../src/app/layout/modules/admin/news-and-events/news-and-events.module.ts",
		"news-and-events.module"
	],
	"./peer-evaluation/peer-evaluation.module": [
		"../../../../../src/app/layout/modules/admin/peer-evaluation/peer-evaluation.module.ts",
		"common",
		"peer-evaluation.module"
	],
	"./programme/programme.module": [
		"../../../../../src/app/layout/modules/admin/programme/programme.module.ts",
		"common"
	],
	"./search/search.module": [
		"../../../../../src/app/layout/modules/admin/search/search.module.ts",
		"common",
		"search.module"
	],
	"./superadmin/superadmin.module": [
		"../../../../../src/app/layout/modules/admin/superadmin/superadmin.module.ts",
		"superadmin.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// G:/UTL/BMI/Admin/Admin-ANG/src/$$_lazy_route_resource lazy
// module id = ../../../../../src/$$_lazy_route_resource lazy recursive
// module chunks = main